import React from "react";
import InformationBanner from "../../../design-system-components/InformationBanner/InformationBanner";
import { defineMessages, useIntl } from "react-intl";
import { useUrl } from "../../../hooks/usePage";
import { Pagetype, WorkModeStatus } from "../../../interfaces/Config";
import { isTeacherWhenNoStudentSoloAi } from "../../Workmodes/workmodesMessages";
import { useWorkmodeConfig } from "../../../hooks/useConfig";
import { UserType } from "../../../interfaces/User";
import { WorkModeType } from "@evidenceb/athena-common/interfaces/Workmode";

const WithoutAiInformatonBanner = () => {
    const urlPlaylist = useUrl(Pagetype.WORKMODE_PLAYLIST);
    const intl = useIntl();
    const soloAIConfig = useWorkmodeConfig(WorkModeType.SoloAI);
    const playlistConfig = useWorkmodeConfig(WorkModeType.Playlist);

    // if students HAVE solo Ai we don't show the banner
    if (!isTeacherWhenNoStudentSoloAi(soloAIConfig, UserType.Teacher)) {
        return null;
    }

    /*  
        if playlists are NOT active we don't show the No Ai banner
        because the teacher needs the playlist to work with the students
        when there is no SoloAi mode active
        
    */
    if (playlistConfig?.status !== WorkModeStatus.Active) {
        return null;
    }
    return (
        <InformationBanner
            data={{
                content: intl.formatMessage(messages.soloNoIa, {
                    a: (chunks: any[]) => <a href={urlPlaylist}>{chunks}</a>,
                }),
            }}
        />
    );
};
export default WithoutAiInformatonBanner;

const messages = defineMessages({
    soloNoIa: {
        id: "informationBanner-soloNoIa",
        defaultMessage:
            "This catalog is only visible to the teacher. So that your students can practice these modules, please <a>create a compilation</a> and add the exercises of your choice, then share it with them.",
    },
});
